<script setup lang="ts">
import TheIcon from '@/components/atoms/TheIcon/TheIcon.vue'
import { useAuthenticationStore } from '@/stores/useAuthenticationStore'
import { useUserStore } from '@/stores/userStore'
import { storeToRefs } from 'pinia'
import { RouterLink } from 'vue-router'
import { computed } from 'vue'
import { useAppConfigurationStore } from '@/stores/useAppConfigurationStore'

const appConfigStore = useAppConfigurationStore()
const userStore = useUserStore()
const { user } = storeToRefs(userStore)
const authStore = useAuthenticationStore()
const { isLoggedIn, userFirstName, userLastname } = storeToRefs(authStore)

const shouldShowProfileText = computed(() => {
    return (
        (user.value?.name?.trim().length ?? 0) > 0 ||
        (userFirstName.value?.trim().length ?? 0) > 0 &&
        (userLastname.value?.trim().length ?? 0) > 0
    );
});

</script>
<template>
    <div class="profile">
        <div class="profile__avatar" v-if="isLoggedIn">
            <TheIcon name="userCircle" class="profile__icon" />
        </div>
        <div class="profile__info">
            <template v-if="!isLoggedIn">
                <a class="profile__login-button"
                    @click="authStore.startLogin()">Log
                    ind/Opret konto</a>
            </template>
            <template v-else>
                <div class="profile__text" v-if="shouldShowProfileText">
                    Hej, {{ user?.name ?? `${userFirstName} ${userLastname}` }}
                </div>
                <nav>
                    <RouterLink class="profile__link"
                        v-show="appConfigStore.configuration.header.showOrganizer"
                        :to="{ name: 'edit-organizers' }">Arrangører
                    </RouterLink>
                    <RouterLink class="profile__link"
                        :to="{ name: 'edit-profile' }">{{
                            $t('navigation.header.profile') }}</RouterLink>
                    <a class="profile__link" @click="authStore.logout()">
                        Log ud
                    </a>
                </nav>
            </template>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.profile {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: $dn-blue;

    @include media-breakpoint-only(lg) {
        font-size: 15px;
    }

    &__avatar {
        display: flex;
        width: 56px;
        height: 56px;
        align-items: center;
        background-color: $dn-yellow;
        border-radius: 28px;
        margin: 0 26px 0 0;
        font-size: 30px;
        justify-content: center;

        @include media-breakpoint-only(lg) {
            margin: 0 20px;
            font-size: 22px;
            width: 46px;
            height: 46px;
        }

        @include media-breakpoint-up(xl) {
            margin: 0 26px;
        }
    }

    &__icon {
        color: $dn-blue;
        font-size: 40px;
    }

    &__text {
        margin-bottom: 5px;
        font-weight: $font-weight-bold;
    }

    &__link {
        font-weight: $font-weight-normal;
        font-size: 18px;
        margin: 0 15px 0 0;
        color: inherit;
        text-decoration-color: $dn-blue;
        cursor: pointer;

        @include media-breakpoint-only(lg) {
            margin: 0 8px 0 0;
        }
    }

    &__login-button {
        font-weight: $font-weight-bold;
        font-size: 18px;
        margin: 0 15px 0 0;
        color: inherit;
        text-decoration: none;
        text-transform: uppercase;
        cursor: pointer;

        @include media-breakpoint-only(lg) {
            margin: 0 8px 0 0;
        }
    }

    &__info {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
}


.mineture-tidtiltur-dk {
    .profile__avatar {
        background-color: $dn-tidtiltur-green;

    }
}

.events-naturensuge-dk {
    .profile__avatar {
        background-color: $dn-naturensuge-let;

        svg {
            color: $dn-naturensuge-jord !important;
        }

    }

    .profile__text {
        font-style: normal;
    }

    .profile__link {
        color: #fff;
        font-family: "Lato";
        font-size: 14px;
        text-decoration: underline;
    }


    @include media-breakpoint-down(lg) {
        .profile__login-button,.profile__link,.profile__text {
            color: #000 !important;

        }
            

    }
}
.mineindsamlinger-affaldsindsamlingen-dk,
.events-affaldsindsamlingen-dk,
.lokaleevents-dn-dk,
.arrangementer-dn-dk {
  .profile {
    color: $dn-white;
    .profile__avatar {
      background-color: $dn-v2-light-green;
    }
    .profile__link {
      color: $dn-white;
    }
  }

}

</style>
